import { createAsyncThunk } from '@reduxjs/toolkit';

import * as OrderService from 'Services/OrderService';

import { orderLoadSuccessFromPaymentSuccess } from 'dux/checkoutOrder/actions';
import { trackOrderSuccess, trackPurchaseCompleted } from 'dux/tracking/actions';

export const saveStripePayment = createAsyncThunk(
  'checkoutPayment/saveStripePayment',
  async ({ nameOnCard, stripe, cardElement }, { rejectWithValue }) => {
    try {
      const { token, error } = await stripe.createToken(cardElement, {
        name: nameOnCard,
      });
      if (error) {
        return rejectWithValue({ error, status: 'error' });
      }
      return { token, status: 'success' };
    } catch (error) {
      return rejectWithValue({ error, status: 'failure' });
    }
  }
);

export const savePayment = createAsyncThunk(
  'checkoutPayment/savePayment',
  async ({ values, stripe, cardElement }, { rejectWithValue }) => {
    try {
      if (values.cardPubkey && values.cardPubkey !== 'newCard') {
        return { cardPubkey: values.cardPubkey, status: 'success' };
      }
      const { token, error } = await stripe.createToken(cardElement, {
        name: values.nameOnCard,
      });
      if (error) {
        return rejectWithValue({ error, status: 'error' });
      }
      return { token, status: 'success' };
    } catch (error) {
      return rejectWithValue({ error, status: 'failure' });
    }
  }
);

export const payWithButton = createAsyncThunk(
  'checkoutPayment/payWithButton',
  async ({ paymentType, saveCard, token }, { dispatch, rejectWithValue }) => {
    try {
      const order = await OrderService.post(token.id, saveCard);
      dispatch(orderLoadSuccessFromPaymentSuccess(order));
      dispatch(trackOrderSuccess(order));
      dispatch(
        trackPurchaseCompleted({
          express_checkout: false,
          payment_location: 'cart',
          payment_type: paymentType,
        })
      );
      return { status: 'success', order };
    } catch (error) {
      return rejectWithValue({ error, status: 'failure' });
    }
  }
);

export const payWithButtonV2 = createAsyncThunk(
  'checkoutPayment/payWithButtonV2',
  async ({ paymentType, saveCard, token }, { dispatch, rejectWithValue }) => {
    try {
      const order = await OrderService.postV2(token.id, saveCard);
      dispatch(orderLoadSuccessFromPaymentSuccess(order));
      dispatch(
        trackPurchaseCompleted({
          express_checkout: false,
          payment_location: 'cart',
          payment_type: paymentType,
        })
      );
      return { status: 'success', order };
    } catch (error) {
      return rejectWithValue({ error, status: 'failure' });
    }
  }
);
